export default function ensureTimezoneSuffix(dateString:string) {
  // Regex to check for a time component starting with 'T'
  const timeComponentRegex = /T\d{2}:\d{2}:\d{2}/;

  // If dateString does not contain a time component, append one
  if (dateString && !timeComponentRegex.test(dateString)) {
    dateString += "T20:00:00.000Z";
  }
  
  // Return the updated or original dateString
  return dateString;
}
